import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIResponse } from 'src/app/core/models/api-response';
import { IAskForQuotation, IQuotation, IQuotationDetail } from '../models/quotes.models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class QuotesService {
  constructor(private http: HttpClient) {}

  public getQuotations(): Observable<APIResponse<IQuotation>> {
    return this.http.get<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations'
    );
  }

  public getQuotationById(id: number): Observable<APIResponse<IQuotationDetail>> {
    return this.http.get<APIResponse<IQuotationDetail>>(
      environment.BASE_URL_API + 'retailers/quotations/' + id
    );
  }

  public addAskForQuotation(ask_for_quote: IAskForQuotation): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/ask-for-quotation',
      ask_for_quote
    );
  }

  public draftAskForQuotation(
    ask_for_quote: IAskForQuotation
  ): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/draft-new-quotation',
      ask_for_quote
    );
  }

  public editAndAskForQuotation(
    id: number,
    ask_for_quote: IAskForQuotation
  ): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/' + id + '/edit-and-ask',
      ask_for_quote
    );
  }

  public sendRequest(id: number): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/' + id + '/send-request',
      {}
    );
  }

  public acceptQuotation(id: number): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/' + id + '/accept',
      {}
    );
  }

  public declineQuotation(id: number): Observable<APIResponse<IQuotation>> {
    return this.http.post<APIResponse<IQuotation>>(
      environment.BASE_URL_API + 'retailers/quotations/' + id + '/cancel',
      {}
    );
  }

  public getPdfQuotation(id: number): Observable<Blob> {
    return this.http.get<Blob>(environment.BASE_URL_API + 'retailers/quotations/' + id + '/pdf', {
      responseType: 'blob' as 'json',
    });
  }
}
